import { Box, ThemeProvider, Paper, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { colors } from '@src/styles';
import { selectDarkTheme } from '@src/styles/darkTheme';
import { CanonicalDetails, CanonicalGrid, CanonicalDialog, CanonicalOrganizationDetails } from './components';
import { useCanonicalsContext } from './CanonicalsContext';

export const CanonicalsView = () => {
  const {
    canonicals,
    selectedCanonical,
    selectedCanonicalOrganizationId,
    organizationsMap,
    isLoading,
    isCreating,
    isEditing,
    handleCanonicalClick,
    handleCloseOrganizationDetails,
    handleCreateNew,
    handleSave,
    handleCancel,
  } = useCanonicalsContext();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <ThemeProvider theme={selectDarkTheme}>
      <Box
        sx={{
          height: '100%',
          display: 'flex',
        }}
      >
        <Paper
          elevation={0}
          sx={{
            width: '100%',
            height: isMobile ? 'auto' : 'calc(100vh - 56px)',
            minHeight: 0,
            overflow: isMobile ? 'visible' : 'hidden',
            padding: isMobile ? '12px 4px 16px' : '18px 24px 16px',
            margin: '0px',
            gap: '16px',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: colors.background.primary,
            backgroundImage: 'none',
            color: colors.primary.white,
            border: 'none',
            position: 'relative',
          }}
        >
          {selectedCanonicalOrganizationId && selectedCanonical ? (
            <CanonicalOrganizationDetails
              organizationId={selectedCanonicalOrganizationId}
              organizationName={organizationsMap[selectedCanonicalOrganizationId] || selectedCanonicalOrganizationId}
              onBack={handleCloseOrganizationDetails}
            />
          ) : selectedCanonical ? (
            <CanonicalDetails />
          ) : (
            <CanonicalGrid
              isLoadingCanonicals={isLoading}
              canonicals={canonicals}
              onCanonicalClick={handleCanonicalClick}
              onCreateNew={handleCreateNew}
            />
          )}

          <CanonicalDialog
            open={isCreating || isEditing}
            isCreating={isCreating}
            selectedCanonical={selectedCanonical}
            onSave={handleSave}
            onCancel={handleCancel}
          />
        </Paper>
      </Box>
    </ThemeProvider>
  );
};
